import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import Spinner from '../components/spinner';
import { ACTIONS } from '../../actions/actionTypes';

class CuriositiesView extends Component {
    constructor() {
        super();
        this.state = {
            disabled: true
        };
    }

    componentDidMount () {
        this.props.setCuriosityShowed(this.props.curiosity);
        this.handleDisabled();
    }

    handleDisabled() {
        setInterval(() => {
            this.setState({
                disabled: false
            });
        }, 5000);
    }

    render () {
        // console.log('curiosity', this.props.curiosity);

        if (this.props.curiosity.loading) {
            return (
                <div className='view-background magazine'>
                    <Spinner />
                </div>
            );
        }

        let {curiosity} = this.props.curiosity;

        return (
            <div className='view-background magazine'>
                <div className='content'>
                    <div className='flex'>
                        <div className='text'>
                            <h1 className='title'>
                                {curiosity.area ? curiosity.area.title : 'Area'}
                            </h1>
                            <span>
                                {curiosity.curiosity ? curiosity.curiosity.description : 'Description'}
                            </span>
                        </div>

                        {this.state.disabled ?
                            <div className='btn center curiosity disabled'>
                                <h4>Ok</h4>
                            </div> :
                            <div className='btn center curiosity' onClick={() => this.props.push('/')}>
                                <h4>Ok</h4>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    curiosity: state.curiosity
});

const mapActions = (dispatch) => ({
    push: (location) => dispatch(push(location)),
    setCuriosityShowed: (item) => dispatch({type: ACTIONS.SET_CURIOSITY_SHOWED, payload: item})
});

export default connect(mapStateToProps, mapActions)(CuriositiesView);



// WEBPACK FOOTER //
// ./src/views/DashboardViews/curiositiesView.js